import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';

@Component({
  name: 'CmgClearWalletModal',
})
export default class CmgClearWalletModal extends Vue {

  get visible(): boolean {
    return this.$appStore.state.ui.modals.clearWalletModal.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }
  
  get closeButtonImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }

  resume() {    
    this.$services.ui.setModalVisibility('clearWalletModal', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }
}